import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { environment } from '../../../environments/environment';

const http_options = {
	headers: new HttpHeaders({
		'Content-Type': 'application/json'
	})
};

class District {
	district_name:string;
}

@Injectable()
export class DistrictService {

	private url = environment.url;
	public selected_district:string=null;

	constructor(private http: HttpClient) { }

	addNewDistrict(form): Observable<string>{
		return this.http.post<string>(this.url + '/masters/district/submit', form, http_options);
	};

	getDistrict(): Observable<District[]> {
		return this.http.get<District[]>(this.url + '/masters/district/all');
	};
	getDistrictFormWith(name:string): Observable<District[]> {
		console.log (this.http.get<District[]>(this.url + '/masters/district/get/' + name));
		return this.http.get<District[]>(this.url + '/masters/district/get/' + name);
	};
}




// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/_services/_masters/district.service.ts